import React from 'react';

export const LevelSelectPage: React.FC = () => {
  return (
    <div className="text-center py-16">
      <h1 className="text-2xl font-bold text-foreground mb-2">
        Level Select
      </h1>
      <p className="text-muted-foreground">
        Level selection will be implemented here
      </p>
    </div>
  );
};